"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_API_INSTANCE = exports.SET_API_INSTANCE_IS_LOADING = exports.FETCH_API_INSTANCE_LIST = exports.DELETE_API_INSTANCE = exports.CREATE_EXTERNAL_API_INSTANCE = void 0;
var _actionify = require("@mulesoft/actionify");
var FETCH_API_INSTANCE_LIST = exports.FETCH_API_INSTANCE_LIST = (0, _actionify.buildActionsFor)('Fetch API instance list');
var CREATE_EXTERNAL_API_INSTANCE = exports.CREATE_EXTERNAL_API_INSTANCE = (0, _actionify.buildActionsFor)('Create API instance request');
var UPDATE_API_INSTANCE = exports.UPDATE_API_INSTANCE = (0, _actionify.buildActionsFor)('Update API instance');
var DELETE_API_INSTANCE = exports.DELETE_API_INSTANCE = (0, _actionify.buildActionsFor)('Delete API instance');
var SET_API_INSTANCE_IS_LOADING = exports.SET_API_INSTANCE_IS_LOADING = 'Set API instance is loading';
//# sourceMappingURL=actionTypes.js.map